export default "__VITE_ASSET__0bcdf1d7__"